import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Check } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';

import { gray100, primaryButtonOutlinedColor } from '../../../constants/Colors';
import { sideBarWidth } from '../../../constants/Location';
import { AuthContext } from '../../../contexts/auth';
import SideBar from '../../uiParts/SideBar';
import CustomSnackbar from '../../uiParts/CustomSnackbar';
import { browserBack } from '../../../modules/error';
import CustomHead from '../CustomHead';

const styles = {
  button: {
    fontSize: '16px',
    fontWeight: 500,
    mt: '108px'
  },
  container: {
    m: '0 auto',
    p: `200px 0 0 ${sideBarWidth}`,
    width: `calc(560px + ${sideBarWidth})`,
    '@media screen and (max-width: 960px)': {
      m: '0 auto',
      maxWidth: '560px',
      p: '120px 0 0',
      width: '90%'
    }
  },
  icon: {
    fontSize: '80px',
    width: '100%',
    '@media screen and (max-width: 960px)': {
      fontSize: '64px'
    }
  },
  pageWrapper: {
    '@media screen and (max-width: 960px)': {
      flexDirection: 'column'
    }
  },
  primaryButtonOutlinedColor,
  title: {
    color: gray100,
    fontSize: '24px',
    fontWeight: 500,
    mt: '16px',
    '@media screen and (max-width: 960px)': {
      textAlign: 'center',
      maxWidth: '243px'
    }
  }
};

const ProductDeleteComplete: React.FC = () => {
  const navigate = useNavigate();

  // ログインチェック
  const { isLoggedIn } = useContext(AuthContext);
  useEffect((): void => {
    if (!isLoggedIn) {
      navigate('/auth/login');
      return;
    }
  }, []);

  const [finishStatus, setFinishStatus] = useState(false);
  const [open, setOpen] = useState(false);

  const browserBackAlert = (e: { preventDefault: () => void }): void => {
    if (!finishStatus) {
      e.preventDefault();
      setOpen(true);
      window.history.pushState(null, '', window.location.pathname);
      setFinishStatus(false);
    }
  };

  useEffect(() => {
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', browserBackAlert);
    return () => {
      window.removeEventListener('popstate', browserBackAlert);
    };
  }, []);

  return (
    <>
      <CustomHead title="建材削除完了 | CMCOS[コムコス]" />
      <Grid container sx={styles.pageWrapper}>
        <SideBar />
        <Grid
          alignItems="center"
          container
          direction="column"
          item
          sx={styles.container}
        >
          <Check sx={styles.icon} />
          <Typography sx={styles.title}>建材を削除しました</Typography>
          <Button
            fullWidth
            onClick={() => navigate('/product')}
            sx={[styles.button, primaryButtonOutlinedColor]}
            variant="outlined"
          >
            建材登録へ
          </Button>
        </Grid>
      </Grid>
      <CustomSnackbar
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
        open={open}
        text={browserBack}
      />
    </>
  );
};

export default ProductDeleteComplete;
